import { Component, Input, OnInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, Validators, FormGroupDirective } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute } from '@angular/router';
import { Tecnologia } from 'src/app/models/Tecnologia';
import { StepperServiceService } from '../../shared/services/stepper-service.service';
import { TecnologiasService } from '../../shared/services/tecnologias.service';
import { EditNameDialogComponent } from '../edit-name-dialog/edit-name-dialog.component';
import { RemoveDialogComponent } from '../remove-dialog/remove-dialog.component';
import { TechDialogComponent } from '../tech-dialog/tech-dialog.component';
import { Output, EventEmitter } from '@angular/core';
import { LanguageService } from '../../shared/services/language.service';
import { GCMService } from '../../shared/services/gcm.service';
import { UsersManagementService } from 'src/app/modules/shared/services/usersManagement.service';
import { TechnologiesManagementService } from '../../shared/services/technologiesManagement.service';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { CatalogService } from '../../shared/services/catalog.service';
import { catchError, delay, retryWhen, scan, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { throwError, Subject } from 'rxjs';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';
import { getCatalogErrorMessages } from 'src/app/constants/catalog-error-messages';
import { Permission } from '../../shared/security/permission';
import { PermissionService } from '../../shared/services/permission.service';



@Component({
  standalone: false,
  selector: 'app-technology',
  templateUrl: './technology.component.html',
  styleUrls: ['./technology.component.css']
})
export class TechnologyComponent implements OnInit, OnChanges {
  @Output() valueChange = new EventEmitter<boolean>(); // Defina como boolean


  Permission = Permission;
  variables: any;
  hasUpdates: boolean = false;

  @Input() stepper!: MatStepper;
  @Input() isStepperReset: boolean = false;

  // Form and sub form, needed to link parent form with this component form.
  form: any;
  @Input() canEditCatalog: boolean = false;
  regions: any = [];
  allRegions: any = [];
  allTechs: any = [];
  subForm: any;
  catalogs: any; //List of technologies
  isSelected: boolean = false; //Toggle to check if a item is selected
  selectedItem: any;
  selectedCatalogId: any = null; //Track the currently selected catalog ID
  lastLoadedCatalogId: string | null = null;
  filterCatalogs: any;

  errorDetected: boolean = false;
  errorText: string = "";
  isLoading: boolean = true;

  // Pagination & search
  pageIndex: number = 0;
  pageSize: number = 10;
  totalElements: number = 0;
  searchTerm: string = '';
  private searchSubject = new Subject<string>();

  errorMessages: any;

  @Output() technologyEvent = new EventEmitter<any>();
  @Output() isNewTechnologyEvent = new EventEmitter<boolean>();
  @Output() nextStepEvent = new EventEmitter<boolean>();
  @Output() adminEvent = new EventEmitter<boolean>();

  constructor(private _formBuilder: FormBuilder,
    public authService: AuthService,
    private ctrlContainer: FormGroupDirective,
    private catalogService: CatalogService,
    private tecnologiasManagementService: TechnologiesManagementService,
    private GCMService: GCMService,
    private route: ActivatedRoute,
    private technologyService: TecnologiasService,
    public dialog: MatDialog,
    private infoBar: InfoBarWithStatusService,
    private service: StepperServiceService,
    private languageService: LanguageService,
    private UsersManagementService: UsersManagementService,
    public permissionService: PermissionService,
    private router: Router,
  ) { }

  ngOnInit(): void {


    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
      this.errorMessages = getCatalogErrorMessages(this.variables);
    });



    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(term => {
      this.searchTerm = term;
      this.pageIndex = 0;
      this.getAllCatalogs();
    });

    this.getAllCatalogs();



    this.subForm = this._formBuilder.group({
      firstCtrl: [''],
    })

  }

  getAllCatalogs(autoSelectCatalogId?: string, keepNewTechnologyState: boolean = false) {
    this.isLoading = true;

    this.catalogService.myCatalogs(this.pageIndex, this.pageSize, this.searchTerm).pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error; // Exceeded retry attempts, propagate error
            }
            return retryCount + 1;
          }, 0),
          delay(2500) // Delay between retries (2.5 seconds)
        )
      ),
      catchError(err => {
        console.error('Error fetching techs:', err);
        this.errorDetected = true;
        this.errorText = this.variables.detectedError;
        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any) => {
        try {
          this.catalogs = data.content;
          this.filterCatalogs = data.content;
          this.totalElements = data.totalElements;
        } catch (err) {
          console.error('Error processing data:', err);
          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (this.catalogs && !this.errorDetected) {
          this.isLoading = false;

          if (autoSelectCatalogId) {
            this.selectCatalog(autoSelectCatalogId, keepNewTechnologyState);
          }
        }
      }
    });

  }

  onPageChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.resetSelection();
    this.getAllCatalogs();
  }

  getCatalogById(id: string, keepNewTechnologyState: boolean = false) {

    this.catalogService.getCatalogById(id).pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error; // Exceeded retry attempts, propagate error
            }
            return retryCount + 1;
          }, 0),
          delay(2500) // Delay between retries (2.5 seconds)
        )
      ),
      catchError(err => {
        console.error('Error fetching techs:', err);
        this.errorDetected = true;
        this.errorText = this.variables.detectedError;
        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any[]) => {
        try {
          this.selectedItem = data;
          this.selectedItem.catalogID = id;
        }
        catch (err) {
          console.error('Error processing data:', err);
          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (this.selectedItem && !this.errorDetected) {
          this.isLoading = false;
          const hasCatalogChanged = this.lastLoadedCatalogId !== id;

          this.technologyEvent.emit(this.selectedItem);
          //if (hasCatalogChanged && !keepNewTechnologyState) {
            this.isNewTechnologyEvent.emit(false);
          //}

          this.lastLoadedCatalogId = id;
        }
      }
    });

  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.isStepperReset && changes.isStepperReset.currentValue) {
      this.resetSelection();
      this.ngOnInit();
    }

  }

  openDialog() {
    let dialogRef = this.dialog.open(TechDialogComponent);

    dialogRef.afterClosed().subscribe(result => {

      if (result?.data?.success) {
        this.infoBar.showSnackbar(this.variables.catalogAddedSuccessfully, ['successful-snackbar'], 4000);
        this.isNewTechnologyEvent.emit(true);

        const createdCatalogId = result.data.createdCatalogId;
        this.getAllCatalogs(createdCatalogId, true);
      }
    });
  }

  private selectCatalog(catalogId: string, keepNewTechnologyState: boolean = false) {
    this.isSelected = true;
    this.selectedCatalogId = catalogId;

    if (this.subForm && this.subForm.controls['firstCtrl']) {
      this.subForm.controls['firstCtrl'].setValue(catalogId);
    }

    this.scrollToCatalogItem(catalogId);

    this.getCatalogById(catalogId, keepNewTechnologyState);
  }

  private scrollToCatalogItem(catalogId: string) {
    // Wait for the list to render before trying to scroll to the selected item.
    setTimeout(() => {
      const selectedElement = document.getElementById(`catalog-item-${catalogId}`);
      selectedElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 0);
  }

  sendValue(value: boolean) {
    this.valueChange.emit(value);
  }

  next() {
    this.nextStepEvent.emit(true);
  }

  openDialogRemove(value: Tecnologia) {
    let dialogRef = this.dialog.open(RemoveDialogComponent);

    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        this.technologyService.removeCatalog(value.id).subscribe
          ({
            next: (data) => {
              if (data) {
                this.getAllCatalogs();
                this.infoBar.showSnackbar(this.variables.catalogDeletedSuccessfully, ['successful-snackbar'], 4000);

              }
            },
            error: (error) => {
              console.error('Error:', error.error);

              const message = this.errorMessages[error.error.message]
              this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);
            }
          });
      }


      //De-select the item and flip the toggle.
      this.resetSelection();
    })

  }

  openDialogEditName(catalogId: string, state: any) {
    //Pass the item to be modified to the dialog component
    let dialogRef = this.dialog.open(EditNameDialogComponent, {
      data: {
        catalogId: catalogId,
        state: state,
      }
    });

    //After closed
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.data.success) {
          this.infoBar.showSnackbar(this.variables.catalogUpdatedSuccessfully, ['successful-snackbar'], 4000);

          this.getAllCatalogs();
        }
        else {
          console.error("Erro ao atualizar nome:", result.data.error);
        }
      }
    })
  }

  resetSelection() {
    this.selectedItem = null; // or default empty object
    this.isSelected = false;
    this.selectedCatalogId = null;
    this.lastLoadedCatalogId = null;

    if (this.subForm && this.subForm.controls['firstCtrl']) {
      this.subForm.controls['firstCtrl'].reset();
    }

    this.technologyEvent.emit(null);
  }

  onRadioClick(event: any, catalogId: any) {
    event.preventDefault();
    event.stopPropagation();
    
    const currentValue = this.subForm.controls['firstCtrl'].value;
    
    // Toggle: if same catalog is clicked, deselect it
    if (currentValue === catalogId) {
      this.isSelected = false;
      this.selectedCatalogId = null;
      this.subForm.controls['firstCtrl'].setValue(null);
      this.selectedItem = null;
      this.technologyEvent.emit(null);
    } else {
      // Different catalog selected
      this.isSelected = true;
      this.selectedCatalogId = catalogId;
      this.subForm.controls['firstCtrl'].setValue(catalogId);
      this.getCatalogById(catalogId);
    }
  }


  onSearchCatalog(event: any) {
    this.searchSubject.next(event.target.value);
  }
}
